'use strict';

var _ = require('lodash');
function ServiceClassGroupConfigService(App) {
  function initClassGroups() {
    if (_.isNil(App.classGroupMapping)) {
      App.classGroupMapping = {};
    }
    if (_.isNil(App.classGroupConfig)) {
      App.classGroupConfig = {};
    }
    if (_.isNil(App.classGroups)) {
      App.classGroups = {};
    }
  }
  function initCabinClass() {
    if (_.isNil(App.classesIndexesMapping)) {
      App.classesIndexesMapping = {};
    }
    if (_.isNil(App.cabinsIndexesMapping)) {
      App.cabinsIndexesMapping = {};
    }
  }
  function parseToKey(hepAttributes, attrsToParse) {
    return _.chain(hepAttributes).pick(attrsToParse).values().compact().join('-').value();
  }
  function prepareClassGroupConfigKey(hepEntry) {
    var attributes = hepEntry.attributes;
    return _.isUndefined(attributes.carrier) ? parseToKey(attributes, ['origin', 'destination', 'tag']) : parseToKey(attributes, ['carrier', 'marketOrigin', 'marketDestination', 'tag']);
  }
  function mapClassGroupsToClasses(serviceClassGroupConfig) {
    return _.transform(serviceClassGroupConfig, function (result, value) {
      if (!result[value.classGroup] && !_.isNil(value.classGroup)) {
        result[value.classGroup] = [];
      }
      if (!_.isNil(value.classGroup)) {
        result[value.classGroup].push(value.className);
      }
    }, {});
  }
  function isSystemLevelHepEntry(hepListElement) {
    return _.isUndefined(hepListElement.attributes) || _.isEmpty(hepListElement.attributes);
  }
  function mapClassGroups(serviceClassGroupConfig) {
    return _.chain(serviceClassGroupConfig).sortBy('classIndex').map('classGroup').uniq().value();
  }
  function buildCabinIndexMapping(serviceClassGroupConfig) {
    return _.transform(serviceClassGroupConfig, function (result, value) {
      var cabinCode = value.cabinCode;
      result[cabinCode] = value.cabinIndex;
    }, {});
  }
  function buildClassIndexMapping(serviceClassGroupConfig) {
    return _.transform(serviceClassGroupConfig, function (result, value) {
      var className = value.className;
      result[className] = value.classIndex;
    }, {});
  }
  function isDefaultHepConfig(hepEntry, paramsField) {
    return isSystemLevelHepEntry(hepEntry) || paramsField === 'nestingParams';
  }
  function getClassesFromDefaultConfig(data, paramsField) {
    var defaultConfig = _.find(data.hepList, function (hepEntry) {
      return isDefaultHepConfig(hepEntry, paramsField);
    });
    return defaultConfig ? _.keyBy(defaultConfig.properties[paramsField], 'className') : {};
  }
  function addMissingClasses(newServiceClassGroupConfig, allServiceClasses) {
    var newClassMapping = _.keyBy(newServiceClassGroupConfig, 'className');
    _.forOwn(newClassMapping, function (clazz) {
      if (!allServiceClasses[clazz.className]) {
        allServiceClasses[clazz.className] = newClassMapping[clazz.className];
      }
    });
  }
  function getServiceClassGroupConfigDifference(key, serviceClassGroupConfig) {
    App.classGroupConfig[key] = App.classGroupConfig[key] || [];
    _.forEach(App.classGroupConfig[key], function (appClassGroupConfig) {
      var commonCabinClass = _.find(serviceClassGroupConfig, {
        cabinIndex: appClassGroupConfig.cabinIndex,
        classIndex: appClassGroupConfig.classIndex
      });
      if (!_.isNil(commonCabinClass)) {
        _.merge(appClassGroupConfig, commonCabinClass);
        _.remove(serviceClassGroupConfig, commonCabinClass);
      }
    });
    return _.concat(App.classGroupConfig[key], serviceClassGroupConfig);
  }
  function setClassGroups(key, serviceClassGroupConfig) {
    App.classGroupMapping[key] = mapClassGroupsToClasses(serviceClassGroupConfig);
    App.classGroupConfig[key] = serviceClassGroupConfig;
    App.classGroups[key] = _.toArray(_.omitBy(mapClassGroups(serviceClassGroupConfig), _.isNil));
  }
  function setCabinClass(key, serviceClassGroupConfig) {
    App.cabinsIndexesMapping[key] = buildCabinIndexMapping(serviceClassGroupConfig);
    App.classesIndexesMapping[key] = buildClassIndexMapping(serviceClassGroupConfig);
  }
  function mapAllClassGroups(classGroups) {
    return _.chain(classGroups).reduce(function (result, value) {
      result.push(value);
      return result;
    }, []).flatten().uniq().value();
  }
  function processAllServiceClassGroupConfig(serviceClassGroupConfig) {
    var uniqueCabins = _.chain(serviceClassGroupConfig).uniqBy('cabinIndex').sortBy('cabinIndex').map('cabinCode').uniq().value();
    App.cabins = _.chain(App.cabins || []).concat(uniqueCabins).uniq().value();
    var uniqueClasses = _.chain(serviceClassGroupConfig).uniqBy('classIndex').sortBy('classIndex').reverse().map('className').uniq().value();
    App.classes = _.chain(App.classes || []).concat(uniqueClasses).uniq().value();
    App.classesIndexesMapping.all = _.extend(buildClassIndexMapping(_.chain(serviceClassGroupConfig).uniqBy('className').value()), App.classesIndexesMapping.all || {});
  }
  function processServiceClassGroupConfig(data, paramsField) {
    initClassGroups();
    initCabinClass();
    var allServiceClasses = getClassesFromDefaultConfig(data, paramsField);
    _.forEach(data.hepList, function (hepEntry) {
      var serviceClassGroupConfig = hepEntry.properties[paramsField];
      addMissingClasses(serviceClassGroupConfig, allServiceClasses);
      if (isDefaultHepConfig(hepEntry, paramsField)) {
        var serviceClassGroupConfigDifference = getServiceClassGroupConfigDifference('default', serviceClassGroupConfig);
        setClassGroups('default', serviceClassGroupConfigDifference);
        setCabinClass('default', serviceClassGroupConfigDifference);
      } else {
        var key = prepareClassGroupConfigKey(hepEntry);
        var classGroupConfigDifference = getServiceClassGroupConfigDifference(key, serviceClassGroupConfig);
        setClassGroups(key, classGroupConfigDifference);
        setCabinClass(key, classGroupConfigDifference);
      }
    });
    processAllServiceClassGroupConfig(_.values(allServiceClasses));
    App.classGroups.all = _.toArray(_.omitBy(_.extend(mapAllClassGroups(App.classGroups), App.classGroups.all || {}), _.isNil));
  }
  return {
    processServiceClassGroupConfig: processServiceClassGroupConfig
  };
}
ServiceClassGroupConfigService.$inject = ['App'];
module.exports = ServiceClassGroupConfigService;